export default __webpack_public_path__ + "static/media/screw4.b982b42c.png";